import React from "react";
import { Dashboard, ViewProfile, Category, AssetType, Level, Roles, Outlets, OutletUsers, KioskOutletUsers, AddMenu, MenuCatalog, MenuIngredients, MenuAddons, AdvertisementMgt, CreateCoupon, CouponsList, UniMenuAddon, PopupAdvertisement, VersionControl, Settings, MenuGroup, MenuPricing, NewMenuAddons, ProductAddonAllocation, ProductPriceUpdate, CustomerSupportMgt, CancellationRequest, AddPurchase, PurchaseList, OutletStockTransfer, StorageLocationStTransfer, RMDamageEntries, RmStockReport, CustomerReports, OrderReports, KioskUserReport, UserAnalyticsReport, CouponsReport, DaySummaryReport, MonthSummaryReport, UserCouponReport, CentralStTransaction, ProductSalesReport, ItemWiseReport, OutletStTransaction, AddLevel, ViewLevelRewards, RawMaterials, RMSubCategory, RMMainCategory, RMReorderLevelReport, StorageLocation, AssetStockTransfer, FranchiseEnquiry, Vendors, AddonSalesReport, AddSubsricption, ViewSubsricption, SubscriptionUsers, SubscriptionConsumptionReport, OrderSummary, ItemWiseSummary, AddonSalesSummary, CouponUsageSummary, AllReports, OutletSTransferReport, AdminUserMgt, Logs, ProductStockReport, PromoteProducts, PurchaseUnits, OfferOfDay, PettyCash, LocalProcurement, StockRequest, VendorAllocation, BeverageRequest, CentralRequest, FoodRequest, ProductCreation, AddProduct, AllocateMenuPrice, AllocateAddon, AllocateIngredients, FoodDeliveryApp, StockConsumptionReport, NewArrivals, NotificationScheduler, AutoCouponAllocation, CartScheduler, ProductDetailReport, BroadCast, NewUserCoupon, JourneyCouponReport, UpdateMenu, AddOutlet, EditOutlet, JourneyRevenueReport, AddMenuIngredient, EditMenuIngredient, OutletInventoryReport, OnlineSalesReport, StocksRequest, StockTransfer, MarketingReport, AllEvents, AutomationEvents, PricingUpdateEvents } from "../screens";
import UserCoupon from "../screens/user-coupon-allocation/UserCoupon";
import StorageLocationStReport from "../screens/reports/StorageLocationStReport";
import UserCoupon1 from "../screens/user-coupon-allocation/UserCoupon1";
import OutletDetailScreen from "../components/OutletDetailScreen";
// import ForgotPassword from "../pages/ForgotPassword";

const protectedRoutes = [
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/dashboard/outlet-details/:outletId", element: <OutletDetailScreen /> },
    { path: "/view", element: <ViewProfile /> },

    { path: "/automation/bulk-price-update", element: <ProductPriceUpdate /> },

    { path: "/events", element: <AllEvents /> },
    { path: "/events/automation-events", element: <AutomationEvents /> },
    { path: "/events/pricing-update-events", element: <PricingUpdateEvents /> },

    { path: "/menu/product-creation", element: <ProductCreation /> },
    // { path: "/menu/product-creation", element: <AddProduct /> },
    // { path: "/menu/product-creation", element: <AllocateMenuPrice /> },
    // { path: "/menu/product-creation", element: <AllocateAddon /> },
    // { path: "/menu/product-creation", element: <AllocateIngredients /> },

    { path: "/delivery-app/food-delivery-app", element: <FoodDeliveryApp /> },

    { path: "/menu/category", element: <Category />},
    { path: "/masters/asset-type", element: <AssetType />},
    { path: "/masters/level", element: <Level /> },
    { path: "/masters/menu-group", element: <MenuGroup /> },
    { path: "/masters/menu-pricing", element: <MenuPricing />},
    { path: "/masters/storage-location", element: <StorageLocation />},
    { path: "/masters/vendors", element: <Vendors />},
    { path: "/material/vendor-allocation", element: <VendorAllocation />},

    { path: "/outlet-management/outlets", element: <Outlets /> },
    { path: "/outlet-management/add-outlet", element: <AddOutlet /> },
    { path: "/outlet-management/edit-outlet/:id", element: <EditOutlet /> },

    { path: "/outlet-management/petty-cash", element: <PettyCash /> },
    { path: "/outlet-management/outlet-users", element: <OutletUsers /> },
    { path: "/outlet-management/kiosk-outlet-users", element: <KioskOutletUsers /> },

    { path: "/request-intend/beverage-request", element: <BeverageRequest /> },
    { path: "/request-intend/central-request", element: <CentralRequest /> },
    { path: "/request-intend/food-request", element: <FoodRequest /> },

    { path: "/reports/all-reports", element: <AllReports /> },
    { path: "/reports/customer-reports", element: <CustomerReports /> },
    { path: "/reports/marketing-reports", element: <MarketingReport /> },
    { path: "/reports/order-reports", element: <OrderReports /> },
    { path: "/reports/kiosk-user-reports", element: <KioskUserReport /> },
    { path: "/reports/user-analytics-reports", element: <UserAnalyticsReport /> },
    { path: "/reports/coupons-report", element: <CouponsReport /> },
    { path: "/reports/journey-coupon-report", element: <JourneyCouponReport /> },
    { path: "/reports/journey-revenue-report", element: <JourneyRevenueReport /> },
    { path: "/reports/user-coupon-report", element: <UserCouponReport /> },
    { path: "/reports/day-summary-report", element: <DaySummaryReport /> },
    { path: "/reports/month-summary-report", element: <MonthSummaryReport /> },
    { path: "/reports/product-sales-report", element: <ProductSalesReport /> },
    { path: "/reports/product-detail-report/:productId/:productName/:route", element: <ProductDetailReport /> },
    { path: "/reports/item-wise-report", element: <ItemWiseReport /> },
    { path: "/reports/rm-reorder-report", element: <RMReorderLevelReport /> },
    { path: "/reports/addon-sales-report", element: <AddonSalesReport /> },
    { path: "/reports/outlet-stock-report", element: <OutletSTransferReport /> },
    { path: "/reports/storage-location-stock-report", element: <StorageLocationStReport /> },
    { path: "/reports/out-of-stock-product-report", element: <ProductStockReport /> },
    { path: "/reports/stock-consumption-report", element: <StockConsumptionReport /> },
    { path: "/reports/outlet-inventory-report", element: <OutletInventoryReport /> },
    { path: "/reports/online-sales-report", element: <OnlineSalesReport /> },

    { path: "/transaction/central-stock-report", element: <CentralStTransaction /> },
    { path: "/transaction/outlet-stock-report", element: <OutletStTransaction /> },

    { path: "/menu/add-menu", element: <AddMenu /> },
    { path: "/menu/new-arrivals", element: <NewArrivals /> },
    { path: "/menu/menu-catalog", element: <MenuCatalog /> },
    { path: "/menu/update-menu/:productId", element: <UpdateMenu /> },
    { path: "/menu/menu-ingredients", element: <MenuIngredients /> },
    { path: "/menu/add-menu-ingredients", element: <AddMenuIngredient /> },
    { path: "/menu/edit-menu-ingredients/:id", element: <EditMenuIngredient /> },
    { path: "/menu/menu-addons", element: <MenuAddons /> },
    { path: "/menu/uni-menu-addon", element: <UniMenuAddon /> },
    { path: "/menu/menu-addon", element: <NewMenuAddons /> },
    { path: "/menu/product-addon-allocation", element: <ProductAddonAllocation /> },

    { path: "/purchase/add-purchase", element: <AddPurchase /> },
    { path: "/purchase/local-procurement", element: <LocalProcurement /> },
    { path: "/purchase/purchase-list", element: <PurchaseList /> },
    { path: "/purchase/purchase-units", element: <PurchaseUnits /> },
    { path: "/purchase/stock-request", element: <StockRequest /> },
    { path: "/purchase/outlet-stock-transfer", element: <OutletStockTransfer /> },
    { path: "/purchase/storage-location-stock-transfer", element: <StorageLocationStTransfer /> },
    { path: "/purchase/rm-damage-entries", element: <RMDamageEntries /> },
    { path: "/reports/rm-stock-report", element: <RmStockReport /> },
    { path: "/purchase/stocks-request", element: <StocksRequest /> },
    { path: "/purchase/stock-transfer", element: <StockTransfer /> },


    { path: "/customer-support-mgt", element: <CustomerSupportMgt /> },
    { path: "/cancelation-request", element: <CancellationRequest /> },
    { path: "/franchise-enquiry", element: <FranchiseEnquiry /> },

    { path: "/content-management/advertisement-mgt", element: <AdvertisementMgt /> },
    { path: "/content-management/popup-advertisement", element: <PopupAdvertisement /> },
    { path: "/content-management/promote-products", element: <PromoteProducts /> },

    { path: "/notifications/notification-scheduler", element: <NotificationScheduler /> },
    { path: "/notifications/cart-scheduler", element: <CartScheduler /> },
    { path: "/notifications/broadcast", element: <BroadCast /> },

    { path: "/coupons/offer-of-the-day", element: <OfferOfDay /> },
    { path: "/coupons/auto-coupon-allocation", element: <AutoCouponAllocation /> },
    { path: "/coupons/create-coupon", element: <CreateCoupon /> },
    { path: "/coupons/coupons-list", element: <CouponsList /> },
    { path: "/coupons/user-coupon-allocation", element: <UserCoupon1 /> },

    { path: "/system-preference/version-control", element: <VersionControl /> },
    { path: "/system-preference/settings", element: <Settings /> },
    { path: "/system-preference/logs", element: <Logs /> },

    { path: "/user-level/add-level-reward", element: <AddLevel /> },
    { path: "/user-level/view-level-reward", element: <ViewLevelRewards /> },

    { path: "/material-mgt/raw-materials", element: <RawMaterials /> },
    { path: "/material-mgt/rm-sub-category", element: <RMSubCategory /> },
    { path: "/material-mgt/rm-main-category", element: <RMMainCategory /> },

    { path: "/asset-mgt/asset-stock-transfer", element: <AssetStockTransfer /> },

    { path: "/subscription/add-subscription", element: <AddSubsricption /> },
    { path: "/subscription/view-subscription", element: <ViewSubsricption /> },
    { path: "/subscription/subscription-users", element: <SubscriptionUsers /> },
    { path: "/subscription/subscription-consumption-report", element: <SubscriptionConsumptionReport /> },

    { path: "/summaries/order-summary", element: <OrderSummary /> },
    { path: "/summaries/item-wise-summary", element: <ItemWiseSummary /> },
    { path: "/summaries/addon-sales-summary", element: <AddonSalesSummary /> },
    { path: "/summaries/coupon-usage-summary", element: <CouponUsageSummary /> },

    { path: "/admin-user-mgt/user-mgt", element: <AdminUserMgt /> },
    { path: "/admin-user-mgt/roles", element: <Roles /> },

    // { path: "/account-settings", element: <ForgotPassword /> },

]

export default protectedRoutes